<div class="review">
  <div class="review-image"
       [class.review-image-logo]="!config().personName"
  >
    <img class="image"
         [class.image-person]="config().personName"
         [ngSrc]="config().imageSrc"
         [width]="config().imageWidth || 140"
         [height]="config().imageHeight || 140"
         [alt]="config().imageAlt || 'Review image'"
    >
  </div>

  <div class="review-info">
    @if (config()?.logo?.src) {
      <img class="review-logo"
           [ngSrc]="config().logo.src"
           [width]="config().logo?.width || 100"
           [height]="config().logo?.height || 40"
           [alt]="config().logo?.alt || 'Logo'"
      >
    }

    <p>
      {{ config().text | translate }}
    </p>

    @if (config().personName) {
      <p class="review-person">
        {{ config().personName | translate }}
      </p>
    }

    @if (config().personPosition) {
      <p class="review-position">
        {{ config().personPosition | translate }}
      </p>
    }
  </div>
</div>
